export default {
    url: '/occurrence',
    template: '<ui-view course="vm.course"></ui-view>',
    abstract: true,
    resolve: {
        course (CourseResource, $stateParams) {
            return CourseResource.get({ id: $stateParams.id,
                expand: 'fields,courseFields,courseTrainings,courseTrainingsActiveI18n,activeI18n,courseI18ns,courseTrainingI18ns'
                    + ',courseVersions,courseTrainingForms,sites,company,event,connectedEvents.templates.times,courseTrainings.scormTrainings,' +
                    'courseTrainings.materials,courseTrainings.materials.languages,' +
                    'courseTrainings.materials.chapters.chapterI18ns,courseTrainings.materials.chapters.section.sectionI18ns'
            }).$promise;
        },
        rooms (RoomResource) {
            return RoomResource.query({ pageSize: 0 }).$promise;
        }
    },
    controller ($scope, course, rooms, CourseService) {
        CourseService.nestCompositeModels(course);
        $scope.$parent.vm.step = 4;
        $scope.$parent.vm.course = course;
        $scope.$parent.vm.isArchived = course.isArchived;
        this.course = course;
        this.rooms = rooms;

        $scope.$on('archiveChange', (event, { isArchived }) => {
            $scope.$parent.vm.isArchived = isArchived;
        });
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/courses/edit/occurrence/index.js